import React from 'react'
import { Outlet, NavLink, useLocation } from 'react-router-dom'
import '../../styles/pages.css'

const tabs = [
  { path: '/inventory/list', label: 'Inventory' },
  { path: '/inventory/drafts', label: 'Drafts Manager' },
  { path: '/inventory/cleanup', label: 'Inventory Cleanup' },
  { path: '/inventory/repricing', label: 'Repricing' },
  { path: '/inventory/channel-listings', label: 'Channel Listings' }
]

function InventoryPage() {
  const location = useLocation()

  return (
    <div className="page">
      <div className="pageHead">
        <h1>Inventory</h1>
        <p>Manage stock, pricing, and product data</p>
      </div>

      <div className="pageTabs">
        {tabs.map(tab => (
          <NavLink
            key={tab.path}
            to={tab.path}
            className={location.pathname === tab.path ? 'active' : ''}
          >
            {tab.label}
          </NavLink>
        ))}
      </div>

      <div style={{ marginTop: 28 }}>
        <Outlet />
      </div>
    </div>
  )
}

export default InventoryPage
